import { render, staticRenderFns } from "./DollarPresenter.vue?vue&type=template&id=01e02bee&lang=pug&"
import script from "./DollarPresenter.vue?vue&type=script&lang=ts&"
export * from "./DollarPresenter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports